import script from "./QFZPCOI.vue?vue&type=script&setup=true&lang=js"
export * from "./QFZPCOI.vue?vue&type=script&setup=true&lang=js"

import "./QFZPCOI.vue?vue&type=style&index=0&id=6d8b31a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8b31a8"]])

export default __exports__